import { render, staticRenderFns } from "./ShopInspectionRecord.vue?vue&type=template&id=5fcf901e&scoped=true"
import script from "./ShopInspectionRecord.vue?vue&type=script&lang=ts"
export * from "./ShopInspectionRecord.vue?vue&type=script&lang=ts"
import style0 from "./ShopInspectionRecord.vue?vue&type=style&index=0&id=5fcf901e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fcf901e",
  null
  
)

export default component.exports